// DebugPanel.js
'use strict';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import checkNetworkSpeed from '../action/checkNetworkSpeed';
import recheckDrmCapability from '../action/recheckDrmCapability.js';
import { trackSpeedtestEvent } from '../action/checkNetworkSpeed.js';

import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';

import DebugPanel from '../page/DebugPanel.jsx';

const mapStateToProps = state => {
  const testState = getOperationData(state, ['speedtest'], 'testState');
  // https://github.com/librespeed/speedtest/wiki/speedtest.js
  // testState: -1=not started, 0=starting, 1=download test, 2=ping+jitter test, 3=upload test, 4=finished, 5=aborted
  const isSpeedtesting = [0, 1, 2, 3].includes(testState);
  const isSpeedtested = testState === 4;
  return {
    isSpeedtesting,
    isSpeedtested,
    jitterStatus: getOperationData(state, ['speedtest'], 'jitterStatus'),
    pingStatus: getOperationData(state, ['speedtest'], 'pingStatus'),
    dlProgress: getOperationData(state, ['speedtest'], 'dlProgress'),
    ulProgress: getOperationData(state, ['speedtest'], 'ulProgress'),
    dlStatus: getOperationData(state, ['speedtest'], 'dlStatus'),
    ulStatus: getOperationData(state, ['speedtest'], 'ulStatus'),
    speedtestUnixTimestamp: getOperationData(
      state,
      ['speedtest'],
      'speedtestUnixTimestamp'
    ),
    drmTestStatus: getOperationData(state, ['drm'], 'testStatus'),
    drmTestAtUnixTimestamp: getOperationData(
      state,
      ['drm'],
      'testedAtUnixTimestamp'
    ),
    pusherStatsInitSpeed: getOperationData(
      state,
      ['pusher', 'stats'],
      'initSpeed'
    ),
    pusherStatsConnectSpeed: getOperationData(
      state,
      ['pusher', 'stats'],
      'connectSpeed'
    ),
    messageId: getOperationData(state, ['drm'], 'messageId'),
    abData: getMeData(state, 'ab'),
    notificationPermission: getOperationData(
      state,
      ['permission'],
      'notification'
    ),
    fcmToken: getMeData(state, 'fcmToken'),
    clientTimestamp: getOperationData(state, ['timestamp'], 'client'),
    serverTimestamp: getOperationData(state, ['timestamp'], 'server'),
    clientId: getMeData(state, 'clientId'),
    sessionId: getMeData(state, 'sessionId'),
    configurationData: getOperationData(state, ['config'], 'configurationData'),
    configurationGroups: getOperationData(
      state,
      ['config'],
      'configurationGroups'
    ),
    remoteConfigMerged: getOperationData(
      state,
      ['config'],
      'remoteConfigMerged'
    ),
    currentConfigIds: getOperationData(state, ['config'], 'currentConfigIds'),
    currentConfigKey: getOperationData(state, ['config'], 'currentConfigKey'),
    remoteConfig: state.get('remoteConfig'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    checkNetworkSpeed: () => dispatch(checkNetworkSpeed()),
    recheckDrmCapability: () => dispatch(recheckDrmCapability()),
    trackSpeedtestEvent: () => dispatch(trackSpeedtestEvent()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DebugPanel);
